// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"7071d4db","808":"4c228b46"}[chunkId] + ".chunk.js";
};